import React from 'react'
import * as Styled from './styled'

export interface TourDotsProp {
  numberOfDots: number
  selectedIndex: number
}

export const TourDots: React.FC<TourDotsProp> = ({ numberOfDots, selectedIndex }) => {
  const dots: React.ReactNode[] = []
  // eslint-disable-next-line
  for (let i = 0; i < numberOfDots; i++) {
    dots.push(<Styled.TourDot key={`tour-dot-${i}`} isSelected={i === selectedIndex} />)
  }
  return <>{dots}</>
}
